import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { CreditSalesSlip } from '@/apis/vescajs'

export const TerminalCreditSalesSlip: React.FC<{ receipt: CreditSalesSlip }> = ({ receipt }) => {
  const { t } = useTranslation()
  return (
    <div css={componentStyle}>
      <div className="sales-slip-block">
        <div className="title">
          {t('salesSlipInfo.title')}&emsp;{t('salesSlipInfo.customerCopy')}
        </div>
        <div className="section">
          <span className="label">{t('salesSlipInfo.date')}</span>
          <span>{receipt.transactionAt}</span>
        </div>

        <div className="section">
          <div className="item">
            <span className="label">{t('salesSlipInfo.slipNumber')}</span>
            <span>{receipt.slipNumber}</span>
          </div>
          <div className="item">
            <span className="label">{t('salesSlipInfo.approvalNumber')}</span>
            <span>{receipt.approvalCode}</span>
          </div>
        </div>

        <div className="section">
          <span className="label">{t('salesSlipInfo.cardNumber')}</span>
          <span>{receipt.accountNumber}</span>
        </div>

        <div className="section">
          <span>{t('salesSlipInfo.transactionType')}</span>
          <div className="item">
            <span>{t('salesSlipInfo.sales')}</span>
            <span>{t('salesSlipInfo.oneTimePayment')}</span>
          </div>
        </div>
      </div>
      <hr className="-block" />
    </div>
  )
}

const componentStyle = css({
  '.sales-slip-block': {
    margin: '0 64px',
    fontSize: 24,
    '.title': { textAlign: 'center', fontWeight: 'bold', paddingBottom: '1em' },
    '.section': { display: 'flex', justifyContent: 'space-between' },
    '.item': {
      span: { ':first-of-type': { paddingRight: '1em' } },
    },
  },
  hr: {
    '&.-block': {
      borderTop: '4px dashed #A3A3A3',
      margin: '40px 0',
    },
  },
})
